import type { JSONValue } from "../models/Json";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type IWarehouseStaffRole =
  | "WAREHOUSE_KEEPER"
  | "LOADING_KEEPER"
  | "DELIVERY_SUPERVISOR"
  | "DRIVER";

export type IWarehouseStaffScope = "SINGLE" | "MULTI";

export interface IWarehouseStaffPayload {
  userId: string;
  staffRole: IWarehouseStaffRole;
  scope?: IWarehouseStaffScope;
  canManageStaff?: boolean;
  isPrimary?: boolean;
}

export interface IWarehouseStaffBulkPayload extends IWarehouseStaffPayload {
  warehouseIds: string[];
}

export interface IWarehouseStaffListParams {
  filter?: { staffRole?: IWarehouseStaffRole };
  offset?: { page: number; limit: number };
}

export const list = async (warehouseId: string, params?: IWarehouseStaffListParams) => {
  return httpRequest.get(`/prt/warehouse/${warehouseId}/staff`, params as unknown as Record<string, JSONValue>);
};

export const create = async (warehouseId: string, body: IWarehouseStaffPayload) => {
  return httpRequest.post(`/prt/warehouse/${warehouseId}/staff`, body as unknown as Record<string, JSONValue>);
};

export const bulkCreate = async (body: IWarehouseStaffBulkPayload) => {
  return httpRequest.post("/prt/warehouse/staff/bulk", body as unknown as Record<string, JSONValue>);
};

export const update = async (
  warehouseId: string,
  staffId: string,
  body: Partial<IWarehouseStaffPayload>
) => {
  return httpRequest.put(`/prt/warehouse/${warehouseId}/staff/${staffId}`, body as unknown as Record<string, JSONValue>);
};

export const remove = async (warehouseId: string, staffId: string) => {
  return httpRequest.del(`/prt/warehouse/${warehouseId}/staff/${staffId}`);
};

export const byUser = async (userId: string) => {
  return httpRequest.get(`/prt/user/${userId}/warehouses`);
};

export const mePermissions = async () => {
  return httpRequest.get("/prt/me/warehouse-permissions");
};
